
<template>
    <b-container>
        <b-row class="mb-4" v-if="showHeader">
            <h1 class="text-left mb-0">{{ $t('menuItemStatistics') }}</h1>
            <h2 class="text-left">
                {{ $t('dashboard.statistieken.download') }}
            </h2>
        </b-row>
        <br />
        <h6 class="text-left">{{ $t('dashboard.statistieken.datefrom') }}</h6>
        <b-row>
            <b-col>
                <b-form-datepicker
                    id="start-datepicker"
                    v-model="start"
                    value-as-date
                    class="mb-2"
                    :locale="getLocale"
                    :min="min"
                    :max="end"
                ></b-form-datepicker>
            </b-col>
        </b-row>
        <h6 class="text-left">{{ $t('dashboard.statistieken.dateto') }}</h6>
        <b-row>
            <b-col>
                <b-form-datepicker
                    id="end-datepicker"
                    v-model="end"
                    value-as-date
                    class="mb-2"
                    :locale="getLocale"
                    :min="start"
                    :max="max"
                ></b-form-datepicker>
            </b-col>
        </b-row>
        <br />
        <b-row class="mb-4">
            <b-col>
                <download-item
                    v-for="query in logQueries"
                    :key="query.name"
                    :organizationId="getOrganizationId"
                    :query="query"
                    :start="start"
                    :end="end"
                />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';

    import DownloadItem from './DownloadItem.vue';

    export default {
        components: { 'download-item': DownloadItem },

        props: { showHeader: { type: Boolean, required: false, default: true } },

        data: function () {
            return {
                start: null,
                end: null,
                max: null,
                logQueries: null
            };
        },

        mounted: function () {
            this.init();
        },

        created() {
            const startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 12);
            this.start = startDate;

            const endDate = new Date();
            endDate.setDate(endDate.getDate() - 1);
            this.end = endDate;

            const minDate = new Date();
            minDate.setDate(minDate.getDate() - (5 * 365 + 1));
            this.min = minDate;

            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() - 1);
            this.max = maxDate;
        },

        computed: {
            ...mapGetters(['getLocale']),

            getOrganizationId() {
                return this.$store.state.userInfo.organizationId;
            }
        },

        methods: {
            ...mapActions(['useApiData']),

            init() {
                this.getDownloadableItemsList();
            },

            async getDownloadableItemsList() {
                const logQueriesResult = await this.useApiData({
                    name: 'GetAnalyticsArchiveConfiguration',
                    data: {}
                });
                this.logQueries = logQueriesResult.data;
            }
        }
    };
</script>

<style lang="scss" scoped>
h2 {
    width: 100%;
}
</style>
